import Utils from "../utils/Utils";

const CreditsController = {
  getWalletOverview: ({ companyId, Authorization }) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);

    return Utils.controller(
      "api/wallet/v1/getWalletOverview",
      {},
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },

  getBuyCreditsPopup: ({ jwt }) => {
    return Utils.controller(
      "api/credit/v1/buyCreditsPopup",
      "",
      "GET",
      "",
      true,
      jwt,
      true,
    );
  },

  AddUserCreditCard: ({ Authorization, request }) => {
    return Utils.controller(
      "api/credit/v1/addUserCreditCard",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  BuyCredits: ({ jwt, request }) => {
    return Utils.controller(
      "api/credit/v1/buyCredits",
      request,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },

  getWalletTransactions: ({
    amount,
    companyName,
    dateFrom,
    dateTo,
    description,
    page,
    referenceId,
    sizePage,
    sortBy,
    sortDirection,
    source,
    userType,
    walletStatus,
    walletTransactionId,
    walletType,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    if (amount) params.append("amount", amount);
    if (companyName) params.append("companyName", companyName);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (description) params.append("description", description);
    if (page !== undefined) params.append("page", page);
    if (referenceId) params.append("referenceId", referenceId);
    if (sizePage !== undefined) params.append("sizePage", sizePage);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDirection) params.append("sortDirection", sortDirection);
    if (source) params.append("source", source);
    if (userType) params.append("userType", userType);
    if (walletStatus) params.append("walletStatus", walletStatus);
    if (walletTransactionId) {
      params.append("walletTransactionId", walletTransactionId);
    }
    if (walletType) params.append("walletType", walletType);

    return Utils.controller(
      "api/wallet/v1/getWalletTransactions",
      {},
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },

  getWalletCredits: ({
    page,
    purpose,
    search,
    sizePage,
    sortDirection,
    sortBy,
    dateFrom,
    dateTo,
    companyId,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    if (page !== undefined) params.append("page", page);
    if (purpose) params.append("purpose", purpose);
    if (search) params.append("search", search);
    if (sizePage !== undefined) params.append("sizePage", sizePage);
    if (sortDirection) params.append("sortDirection", sortDirection);
    if (sortBy) params.append("sortBy", sortBy);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (companyId) params.append("companyId", companyId);

    return Utils.controller(
      "api/wallet/v1/getWalletCredits",
      {},
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
  getWalletWithdrawals: ({
    businessName,
    businessType,
    companyId,
    dateFrom,
    dateTo,
    destination,
    maxAmount,
    minAmount,
    page,
    requestId,
    search,
    sizePage,
    sortBy,
    sortDirection,
    status,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    if (businessName) params.append("businessName", businessName);
    if (businessType) params.append("businessType", businessType);
    if (companyId) params.append("companyId", companyId);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (destination) params.append("destination", destination);
    if (maxAmount !== undefined) params.append("maxAmount", maxAmount);
    if (minAmount !== undefined) params.append("minAmount", minAmount);
    if (page !== undefined) params.append("page", page);
    if (requestId) params.append("requestId", requestId);
    if (search) params.append("search", search);
    if (sizePage !== undefined) params.append("sizePage", sizePage);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDirection) params.append("sortDirection", sortDirection);
    if (status) params.append("status", status);

    return Utils.controller(
      "api/wallet/v1/getWalletWithdrawals",
      {},
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
  getWalletBillings: ({
    companyId,
    page,
    search,
    sizePage,
    sortBy,
    sortDirection,
    status,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);
    if (page !== undefined) params.append("page", page);
    if (search) params.append("search", search);
    if (sizePage !== undefined) params.append("sizePage", sizePage);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDirection) params.append("sortDirection", sortDirection);
    if (status) params.append("status", status);

    return Utils.controller(
      "api/wallet/v1/getWalletBillings",
      {},
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
  withdrawalPopup: ({ Authorization, walletId }) => {
    return Utils.controller(
      "api/wallet/v1/withdrawalPopup",
      "",
      "GET",
      `walletId=${walletId}`,
      true,
      Authorization,
      true,
    );
  },

  getUserCreditCards: ({ Authorization, userId }) => {
    return Utils.controller(
      "api/credit/v1/getUserCreditCards",
      "",
      "GET",
      `userId=${userId}`,
      true,
      Authorization,
      true,
    );
  },
  RequestWithdrawal: ({ Authorization, request }) => {
    return Utils.controller(
      "api/wallet/v1/requestWithdrawal",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  AddWallet: ({ Authorization, request }) => {
    return Utils.controller(
      "api/wallet/v1/addWallet",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
};

export default CreditsController;
